import { MENU_CATEGORIES, MEATS } from "@/lib/menuData";
import { Phone, Flame } from "lucide-react";
import { CONTACT } from "@/lib/menuData";

export const MenuGrid = () => {
  return (
    <section id="menu" data-testid="menu-section" className="border-b-2 border-[color:var(--brand-ink)] bg-[color:var(--brand-bg)]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div>
            <p className="font-bold text-sm uppercase tracking-[0.2em] text-[color:var(--brand-red)]">The Menu</p>
            <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl uppercase mt-2">
              What We're Cooking
            </h2>
          </div>
          <div className="inline-flex items-center gap-2 bg-[color:var(--brand-ink)] text-white font-bold uppercase text-sm px-4 py-2 border-2 border-[color:var(--brand-ink)] shadow-brutal-sm self-start md:self-end">
            <Phone size={14} strokeWidth={2.75} />
            Call for pricing
          </div>
        </div>

        {/* Meats callout */}
        <div data-testid="meats-callout" className="mb-10 border-2 border-[color:var(--brand-ink)] bg-white shadow-brutal-sm">
          <div className="flex items-center gap-3 bg-[color:var(--brand-ink)] text-white px-5 py-3">
            <Flame size={18} strokeWidth={2.75} className="text-[color:var(--brand-yellow)]" />
            <h3 className="font-display text-xl sm:text-2xl uppercase">Pick Your Meat</h3>
          </div>
          <div className="p-5 flex flex-wrap gap-2">
            {MEATS.map((m) => (
              <span
                key={m}
                className="inline-block border-2 border-[color:var(--brand-ink)] bg-[color:var(--brand-bg-2)] px-3 py-1 text-sm font-semibold uppercase"
              >
                {m}
              </span>
            ))}
          </div>
        </div>

        {/* Menu cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {MENU_CATEGORIES.map((cat) => (
            <article
              key={cat.key}
              data-testid={`menu-card-${cat.key}`}
              className="relative bg-white border-2 border-[color:var(--brand-ink)] shadow-brutal-sm p-6 flex flex-col"
            >
              {cat.badge && (
                <span className="absolute -top-3 -right-3 bg-[color:var(--brand-yellow)] border-2 border-[color:var(--brand-ink)] px-2 py-0.5 text-xs font-bold uppercase stamp shadow-brutal-sm">
                  {cat.badge}
                </span>
              )}
              <h3 className="font-display text-3xl uppercase">{cat.title}</h3>
              <p className="mt-2 text-[color:var(--brand-ink-2)]">{cat.blurb}</p>
              <ul className="mt-4 space-y-1.5">
                {cat.items.map((it) => (
                  <li key={it} className="text-sm font-medium flex items-start gap-2">
                    <span className="mt-1 inline-block w-2 h-2 bg-[color:var(--brand-red)]" />
                    {it}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        {/* Tamales banner */}
        <div
          data-testid="tamales-banner"
          className="mt-10 relative bg-[color:var(--brand-yellow)] border-2 border-[color:var(--brand-ink)] shadow-brutal p-6 sm:p-8 overflow-hidden"
        >
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div>
              <p className="font-bold text-xs uppercase tracking-[0.2em] text-[color:var(--brand-red)]">Weekend Only</p>
              <h3 className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase leading-none mt-2">
                Tamales — Fri • Sat • Sun
              </h3>
              <p className="mt-3 max-w-xl text-[color:var(--brand-ink-2)]">
                Slow-steamed, wrapped by hand. Only available Friday through Sunday. Get 'em before they're gone.
              </p>
            </div>
            <a
              href={CONTACT.phones[0].href}
              data-testid="tamales-call"
              className="btn-brutal inline-flex items-center gap-2 bg-[color:var(--brand-ink)] text-white font-bold uppercase px-5 py-3 border-2 border-[color:var(--brand-ink)] shadow-brutal-sm"
            >
              <Phone size={16} strokeWidth={2.75} /> Reserve by Phone
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MenuGrid;
